import {PureComponent} from 'react'

import LandingFreelance from './LandingFreelanceUniverse.jsx'

import header from './images/header-finance.png?size=600'

const metaDescription = "Profitez d'un accompagnement personnalisé et accédez à des missions pour consultant expert finance : contrôle de gestion, trésorerie, consolidation et comptabilité."
const metaTitle = "Twineeds | Missions pour experts en finance"

export default class LandingFreelanceFinance extends PureComponent {
  render() {
    const headerBrief = <p>Vous êtes <strong>consultant indépendant</strong> ou <strong>manager de transition en finance</strong> ? Twineeds vous connecte à des missions partout en France, en adéquation avec votre expertise : contrôle de gestion, consolidation, trésorerie, comptabilité, et plus encore.</p>

    return (
      <LandingFreelance
        headerImg={header.src}
        headerImgAlt="PC et portable montrant un site d'intermédiation pour consultants freelances et entreprise"
        headerBrief={headerBrief}
        metaDescription={metaDescription}
        metaOgDescription={metaDescription}
        metaTitle={metaTitle}
        metaOgTitle={metaTitle}
        sectorText="de la finance"
        title="Expert en finance ? Trouvez des missions adaptées à votre expertise"
        universeCode="finance"
      />
    )
  }
}
